import { autoinject, customAttribute } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
declare const $;

@autoinject
@customAttribute('af-jquery-on')
export class JqueryOnCustomAttribute {
  @bindable eventName: string;
  @bindable eventHandler: (...args) => void;

  constructor(private element: Element) { }

  attached() {
    $(this.element).on(this.eventName, this.handleEvent);
  }

  detached() {
    $(this.element).off(this.eventName, this.handleEvent);
  }

  handleEvent = (...args) => this.eventHandler ? this.eventHandler(...args) : void 0;
}
